import { render, staticRenderFns } from "./v-row.vue?vue&type=template&id=550e4f36&scoped=true&"
var script = {}
import style0 from "./v-row.vue?vue&type=style&index=0&id=550e4f36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550e4f36",
  null
  
)

export default component.exports